import { render, staticRenderFns } from "./NavigationItem.vue?vue&type=template&id=aba600ae"
import script from "./NavigationItem.vue?vue&type=script&lang=js"
export * from "./NavigationItem.vue?vue&type=script&lang=js"
import style0 from "./NavigationItem.vue?vue&type=style&index=0&id=aba600ae&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports